export default {
  getUserList: "BackEnd/getUserList",
  getUserListDeatils: "BackEnd/getUserListDeatils",
  setAccountData: "BackEnd/setAccountData",
  updateAccountData: "BackEnd/updateAccountData",
  updateMemberAgree: "BackEnd/updateMemberAgree",
  getKnowledgesCountsRecordDataMyMemberid:
    "BackEnd/getKnowledgesCountsRecordDataMyMemberid",
};
